import * as React from "react";
import {useEffect} from "react";
import {get as lodashGet} from "lodash";
import {useStyles} from "./viewUserLogs.styles";
import {Container} from "../../../../components/container/container.component";
import {Header} from "../../../../components/header/header.component";
import {Pagination} from "../../../../components/pagination";
import {getFormattedDateTime} from "../../../../helpers/datetime";
import classnames from "classnames";
import {Locations as AdminLocations} from "../../constants/locations";
import {Redirect} from "react-router-dom";
import {IFetchUserLogsParams} from "../../api/api";
import {ILog} from "../../interfaces/logs";


export function ViewUserLogsComponent(props) {
	const {
		logs, fetchUserLogs, exchangedData,
	} = props;
	const classes = useStyles({});
	const [pageNr, setPageNr] = React.useState(1);
	const [selectedLog, setSelectedLog] = React.useState(null);
	// let history = useHistory();
	const perPage = 30;
	const userData = lodashGet(exchangedData, "formValues", {});

	useEffect(() => {
		if (userData && userData.id) {
			const userLogsParams: IFetchUserLogsParams = {
				limit: perPage,
				page: pageNr,
				ownerId: userData.id,
			};

			fetchUserLogs(userLogsParams);
		}
	}, [pageNr]);

	const handlePageClick = (selectedPageNr) => {
		setPageNr(selectedPageNr);
		setSelectedLog(null);
	};

	const handleOnRowClick = (log) => {
		setSelectedLog(log);
	};

	if (!Object.keys(userData).length) {
		return (
			<Redirect
				to={{
					pathname: AdminLocations.USERS,
				}}
			/>
		);
	} else {
		return (
			<>
				<Container>
					<Header>
						Logi dla: {userData.login}
					</Header>
					<div className={classes.tablesWrapper}>
						<table className={classes.table}>
							<tbody>
							<tr>
								<th className={classnames(classes.tableHeader, classes.colLP)}>L.p.</th>
								<th className={classnames(classes.tableHeader, classes.colLP)}>Akcja</th>
								<th className={classnames(classes.tableHeader, classes.colLP)}>Wynik</th>
								<th className={classnames(classes.tableHeader, classes.colLP)}>Data</th>
							</tr>
							{logs.items.map((log: ILog, index) => (
								<tr key={log.id} className={classnames(classes.tableRow, {[classes.tableRowSelected]: selectedLog && selectedLog.id === log.id})} onClick={() => {handleOnRowClick(log); }}>
									<td className={classnames(classes.tableCell, {[classes.tableCellEven]: index % 2 === 0})}>{(pageNr - 1) * perPage + index + 1}</td>
									<td className={classnames(classes.tableCell, {[classes.tableCellEven]: index % 2 === 0})}>{log.info}</td>
									<td className={classnames(classes.tableCell, {[classes.tableCellEven]: index % 2 === 0})}>{log.type}</td>
									<td className={classnames(classes.tableCell, {[classes.tableCellEven]: index % 2 === 0})}>{getFormattedDateTime(log.createdAt)}</td>
								</tr>
							))}
							{logs.items.length === 0 ? <tr><td colSpan={4}>Brak wyników</td></tr> : null}
							</tbody>
						</table>
						<table className={classes.logDetailsTable}>
							<tbody>
							<tr>
								<th className={classnames(classes.tableHeader, classes.colLP)} colSpan={2}>Szczegóły loga</th>
							</tr>
							<tr>
								<th className={classnames(classes.tableHeader, classes.colLP)}>Nazwa</th>
								<th className={classnames(classes.tableHeader, classes.colLP)}>Wartość</th>
							</tr>
							{selectedLog
								? (
									<>

										<tr><td>type</td><td>{selectedLog.type}</td></tr>
										<tr><td>info</td><td>{selectedLog.info}</td></tr>
										<tr><td>ownerId</td><td>{selectedLog.ownerId}</td></tr>
										<tr><td>cardId</td><td>{selectedLog.cardId}</td></tr>
										{selectedLog.additionalInfo
											? (
												<>
													<tr>
														<td>additionalInfo</td>
														<td>
															{JSON.stringify(selectedLog.additionalInfo)}
														</td>
													</tr>
												</>
											)
											: null}
										<tr><td>id</td><td>{selectedLog.id}</td></tr>
										<tr><td>createdAt</td><td>{selectedLog.createdAt}</td></tr>
									</>
									)
								: (
									<tr>
										<td colSpan={2}>Nie wybrano loga</td>
									</tr>
								)}
							</tbody>
						</table>
					</div>
				</Container>
				<Pagination page={pageNr} pageCount={logs.pageCount} onPageClick={handlePageClick} />
			</>
		);
	}
}
